type ClassName = string | undefined;

export const joinClassnames = (...classnames: ClassName[]) =>
  classnames.filter(it => !!it).join(" ");
